import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { augmentPaging } from '~/infrastructure/paging';
import { ApiServiceBase, API_NAMES } from '~/services/api';
import { map } from 'rxjs/operators';
import { createHttpParams } from '~/infrastructure/http/params';
import { AuthorizationStatus } from '~/shared/enums/authorization-status.enum';
import { DisposeAuthorizationActionModel } from '~/models/DisposeAuthorizationActionModel';

@Injectable({ providedIn: 'root' })
export class DisposeTransactionsService extends ApiServiceBase {


  FromInventory: any = [];
  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.stocks);
  }

  createDispose(model: any) {
    return this.client.post<string>(this._url(), model);
  }

  getDisposeHistories(paramsObj?: any, model?: any) {
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    return this.http
      .post<any[]>(this._url(`/grid-data`), model, {
        params,
        observe: 'response',
      })
      .pipe(map(augmentPaging));
  }

  getDisposeAuthorization(paramsObj?: any, model?: any) {
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    return this.http
      .post<any[]>(this._url(`/grid-data_Authorization`), model, {
        params,
        observe: 'response',
      })
      .pipe(map(augmentPaging));
  }


  GetDisposeHistoriesByDisposeTo(disposeToId: number, model: any) {
    return this.http
      .post<any[]>(this._url(`/DisposeTo/${disposeToId}/grid-data`), model, {
        observe: 'response'
      })
      .pipe(map(augmentPaging));
  }

  NumberOfStockItemsDisposedLastXMonths(top: number = 10) {
    return this.client.get(this._url(`/NumberOfStockItemsDisposedLastXMonths/${top}`));
  }

  QuantityOfDisposedStockItemsLastXMonths(top: number = 10) {
    return this.client.get(this._url(`/QuantityOfDisposedStockItemsLastXMonths/${top}`));
  }

  NumberOfDisposedTransactionLastXMonths(top: number = 10) {
    return this.client.get(this._url(`/NumberOfDisposedTransactionLastXMonths/${top}`));
  }

  QuantityOfDisposedStockItemsPerDisposedTo(top: number = 10) {
    return this.client.get(this._url(`/QuantityOfDisposedStockItemsPerDisposedTo/${top}`));
  }

  NumberOfStockItemsDisposed(top: number = 10) {
    return this.client.get(this._url(`/NumberOfStockItemsDisposed/${top}`));
  }

  NumberOfStockItemsDisposedByUser(top: number = 10) {
    return this.client.get(this._url(`/NumberOfStockItemsDisposedByUser/${top}`));
  }

  NumberOfStockItemsDisposedPercategory(top: number = 10) {
    return this.client.get(this._url(`/NumberOfStockItemsDisposedPercategory/${top}`));
  }


  updateAuthorizationStatus(model: DisposeAuthorizationActionModel) {
    return this.client.post(this._url(`/Authorization/UpdateStatus`), model);
  }

  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/DisposeTransactions${v}`);
  }
}
